import { Component, OnInit } from '@angular/core';
import { Cliente } from '../../comum/modelos/cliente';
import { Router } from '@angular/router';
import { PontoFisico } from '../../comum/modelos/ponto-fisico';
import { PontoFisicoService } from '../ponto-fisico.service';
import { Paginacao } from '../../comum/modelos/paginacao';
import { Evento } from '../../comum/eventos/evento';
import { ComumService } from '../../comum/comum.service';
import { ConfirmationService } from 'primeng/primeng';
import { CookieService } from 'angular2-cookie/core';
import { AuthService } from '../../auth/auth.service';

@Component({
  selector: 'app-listar-ponto-fisico',
  templateUrl: './listar-ponto-fisico.component.html',
  styleUrls: ['./listar-ponto-fisico.component.css']
})
export class ListarPontoFisicoComponent implements OnInit {

  public cliente: Cliente;
  public paginacao: Paginacao;
  public pontosFisicos: PontoFisico[];
  public evento: Evento;
  public filtroPesquisaRazaoSocialBind: string;
  public loading = false;
  public statusCode: number;

  constructor(
    private _pontoFisicoService: PontoFisicoService,
    private _comumService: ComumService,
    private confirmationService: ConfirmationService,
    private router: Router,
    private _cookieService: CookieService,
    private _authService: AuthService) {
    this.paginacao = new Paginacao();
    this.pontosFisicos = new Array<PontoFisico>();
    this.evento = this._comumService.evento;
    if (this.evento !== undefined) {
      setTimeout(() => {
        this._comumService.cleanEvent();
      }, 3000);
    }
  }

  ngOnInit() {
    this.paginacao.itens = 5;
    this.paginacao.page = 1;
    this.loading = true;

    const self = this;
    self._pontoFisicoService.obterPontosFisicoClienteHttp(parseInt(this._cookieService.get('idCliente')))
      .subscribe((pontosFisicos: PontoFisico[]) => {
        self.pontosFisicos = pontosFisicos;
        self.loading = false;
      });
  }

  pesquisarPorFiltro(filtro: any): void {
    this.filtroPesquisaRazaoSocialBind = filtro.value;
  }

  removerPontoFisico(pontoFisico: PontoFisico): void {
    this.confirmationService.confirm({
      message: 'Tem certeza que deseja excluir o ponto f\u00edsico?',
      accept: () => {
        this.loading = true;
        this._pontoFisicoService.removerPontoFisicoHttp(pontoFisico.idPontoFisico).subscribe(response => {
          this.loading = false;
          this.statusCode = response.status;
          this._comumService.evento.deletar = true;
          this.router.navigate(['listar-ponto-fisico']);
        }, errorCode => {
          this.statusCode = errorCode;
          this.loading = false;
        });
        this.removerPontoFisicoFromList(this.pontosFisicos, pontoFisico);

        setTimeout(() => {
          this.evento.limparEventos();
        }, 3000);
      },
      reject: () => {
      }
    });
  }

  removerPontoFisicoFromList(pontosFisicos: PontoFisico[], pontoFisico: PontoFisico): void {
    const index = this.obterIdPontoFisico(pontosFisicos, pontoFisico);
    pontosFisicos.splice(index, 1);
  }

  obterIdPontoFisico(pontosFisicos: PontoFisico[], pontoFisico: PontoFisico): number {
    return pontosFisicos.indexOf(pontoFisico);
  }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/ponto-fisico/listar-ponto-fisico/listar-ponto-fisico.component.ts